import { BadgeColor } from '@components/Badge';

import { ReceivedGiftItemStatus } from './common';

export const ReceivedPrepaidCardBadgeColor: Record<ReceivedGiftItemStatus, BadgeColor> = {
    ISSUED: 'blue',
    USED: 'gray',
    CANCELED: 'red',
    EXPIRED: 'gray',
};
